export const AURA_PORTAL_BASE_REGEX =
  /^((((https|http)\:\/\/))?aura-portal(-.*)?\.neo4j(-.*)?\.io)|^(\/).*/;

export function isInternalUrl(url: string): boolean {
  return (
    AURA_PORTAL_BASE_REGEX.test(url) ||
    (url.startsWith('/') && !url.startsWith('//'))
  );
}

export function getPath(url: string): string {
  if (url.startsWith('/')) return url;
  try {
    return new URL(url, window.location.origin).pathname;
  } catch {
    return url;
  }
}

export function getPathTail(path: string): string {
  const segments = path.split('/').filter(Boolean);
  return segments.pop() ?? path;
}
